import type { AITTheme } from '@this/shared/ui/theme';

export function getStyles(theme: AITTheme) {
  const brandPrimary = theme.tokens.colors.brand.primary;
  const brandBackground = theme.tokens.colors.brand.background;
  const textPrimary = theme.tokens.colors.text.primary;
  const textSecondary = theme.tokens.colors.text.description;

  const tableHeaderCell = {
    fontSize: '12px',
    fontWeight: 700,
    background: 'transparent',
    borderBottom: '1px solid #D3D7DB',
    lineHeight: 1,
    padding: '0 4px 12px'
  } as const;

  const tableBodyCell = {
    padding: '12px 4px',
    verticalAlign: 'middle' as const,
    fontSize: '14px',
    borderBottom: '1px solid #D3D7DB',
    lineHeight: 1.5
  } as const;

  return {
    pageLayout: {
      width: '100%',
      minWidth: 0,
      boxSizing: 'border-box' as const
    } as const,
    pageHeader: {
      display: 'flex' as const,
      alignItems: 'center' as const,
      justifyContent: 'space-between' as const,
      gap: '16px',
      padding: '20px',
      flexWrap: 'wrap' as const
    } as const,
    pageTitle: {
      margin: 0,
      fontSize: '18px',
      fontWeight: 700,
      color: textPrimary
    } as const,
    contentIn: {
      width: '100%',
      minWidth: 0,
      padding: '0 20px 20px',
      boxSizing: 'border-box' as const
    } as const,
    addButton: {
      width: '200px'
    } as const,
    tableWrapper: {
      width: '100%',
      minWidth: 0,
      maxWidth: '100%',
      overflow: 'hidden' as const
    } as const,
    tableHeaderCell,
    tableHeaderCellActions: {
      ...tableHeaderCell,
      textAlign: 'right' as const
    } as const,
    tableBodyCell,
    tableBodyCellUrl: {
      ...tableBodyCell,
      wordBreak: 'break-all' as const
    } as const,
    tableBodyCellActions: {
      ...tableBodyCell,
      textAlign: 'right' as const
    } as const,
    statusBadge: {
      display: 'inline-flex' as const,
      alignItems: 'center' as const,
      justifyContent: 'center' as const,
      minWidth: '48px',
      padding: '2px 10px',
      borderRadius: '999px',
      fontSize: '12px',
      fontWeight: 700,
      lineHeight: 1.5,
      backgroundColor: brandBackground,
      color: brandPrimary
    } as const,
    statusBadgeLoginOnly: {
      backgroundColor: '#F7F8F9',
      color: '#959595'
    } as const,
    rowActions: {
      display: 'inline-flex' as const,
      alignItems: 'center' as const,
      justifyContent: 'flex-end' as const,
      gap: '12px',
      flexWrap: 'wrap' as const
    } as const,
    viewLink: {
      display: 'inline-flex' as const,
      alignItems: 'center' as const,
      gap: '4px',
      fontSize: '14px',
      fontWeight: 500,
      textDecoration: 'underline',
      textUnderlineOffset: '2px'
    } as const,
    viewLinkIcon: {
      width: '16px',
      height: '16px'
    } as const,
    tableActionButton: {
      height: '32px',
      minHeight: '32px',
      minWidth: '64px',
      padding: '3px 10px',
      boxSizing: 'border-box' as const,
      lineHeight: 1.5,
      fontSize: '0.7544642857142857rem',
      boxShadow: 'none'
    } as const,
    emptyMessage: {
      padding: '24px 20px',
      fontSize: '14px',
      color: textSecondary,
      textAlign: 'center' as const
    } as const
  };
}

export type KnowledgeImagesStyles = ReturnType<typeof getStyles>;
